import React, { memo } from 'react';

import { Typography, useTheme } from '@mui/material';

import { IUiTitleProps } from './ui-title.model';

export const UiTitle = memo<IUiTitleProps>(
  ({ borderColor = 'secondary', title, type }) => {
    const theme = useTheme();

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            height: 30,
            width: 5,
            minWidth: 5,
            borderRadius: 3,
            marginRight: theme.spacing(3),
            backgroundColor:
              borderColor === 'primary'
                ? theme.palette.primary.main
                : theme.palette.secondary.main,
          }}
        />
        <Typography variant="h1" component={type} style={{ fontWeight: 700 }}>
          {title}
        </Typography>
      </div>
    );
  }
);
